import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import './screens.css';

const BillingSuccessScreen = ({ goToHome, goToPlan }) => {
  useEffect(() => {
    // URLパラメータからsession_idを取得（将来的に利用可能）
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');

    if (sessionId) {
      console.log('Checkout session completed:', sessionId);
    }
  }, []);

  return (
    <div className="billing-result-screen">
      <div className="billing-result-container">
        <div className="billing-result-icon success">
          <CheckCircle size={64} />
        </div>

        <h2 className="billing-result-title">購入が完了しました</h2>

        <p className="billing-result-message">
          ご購入ありがとうございます。<br />
          プランまたはクレジットが正常にアクティベートされました。
        </p>

        <div className="billing-result-note">
          <p>
            💡 プラン情報は数秒以内に反映されます。<br />
            反映されない場合は、プラン画面で最新の状態をご確認ください。
          </p>
        </div>

        <div className="billing-result-actions">
          <button
            className="billing-result-button primary"
            onClick={goToHome}
          >
            ホームに戻る
          </button>
          <button
            className="billing-result-button secondary"
            onClick={goToPlan}
          >
            プラン画面を見る
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingSuccessScreen;
